__turbopack_context__.v({
  "item": "J_uoHW_item",
  "link": "J_uoHW_link",
  "placeholder": "J_uoHW_placeholder",
  "text": "J_uoHW_text",
});
